_ = require 'underscore'
Auth = require 'db/auth'
limitErrorPopover = require 'views/lib/limit-error-popover'

trackingArea = "Member Limits"
maybeDisplayOrgMemberLimitsError = (elem, org, member) ->
  m = if org?.isOverLimit('orgs', 'totalMembersPerOrg')
      message: 'members exceeds total per org limit'
      params: { orgName: org.get("name") }
    else if member?.isOverLimit('orgs', 'totalPerMember')
      if Auth.isMe(member)
        message: 'your orgs exceed total per member limit'
      else
        message: 'orgs exceeds total per member limit'
        params: { memberName: member.get("name") }

  if m?
    limitErrorPopover(_.extend({ trackingArea, elem }, m))
    return true
  return false

module.exports = { maybeDisplayOrgMemberLimitsError }



// WEBPACK FOOTER //
// ./app/scripts/views/organization/member-limits-error.coffee